// extracted by mini-css-extract-plugin
export default {"tabs":"Builder_tabs__P0i-e","builder":"Builder_builder__erio6","team":"Builder_team__dQONG","placeholder":"Builder_placeholder__IHuQj","button":"Builder_button__tQDKG"};